module.exports = __webpack_public_path__ + "img/num01.7c151806.svg";